import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { BriefType, CoreEntityType, PublicEditEntityAssetsInfo, publicEditProfileStatusTypes, PublicEditProfileStatusTypesType, ShareableItemTypes } from 'globals/store/share.data';
import { OnInit } from '@angular/core';
import { Performer } from 'globals/store/performers.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { JoiResource } from 'globals/store/resources.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { JoiEvent } from 'globals/store/events.data';
import { associatedAssetsReselector } from 'src/app/store/reselectors/entity.reselector';
import { Asset } from 'globals/store/assets.data';
import { Dictionary } from '@ngrx/entity';
import { AssetCardComponent } from 'src/app/components/cards/asset-card.component';
import { TitleToggleComponent } from 'src/app/components/wrappers/title-toggle-wrapper.component';
import { CommonModule } from '@angular/common';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { AddLinkToBriefComponent } from 'src/app/components/wrappers/add-link-to-brief-wrapper.component';

@Component({
    selector: 'edit-associated-assets-manager',
    templateUrl: './edit-associated-assets-mangager.html',
    styles: [`
  :host { display: block; }  
  .body { margin: 0 10px 10px; }
`],
    standalone: true,
    imports: [AssetCardComponent, AddLinkToBriefComponent, BinaryShareToggle, TitleToggleComponent, CommonModule ],
})
export class EditAssociatedAssetsManager extends Wrapper<EditAssociatedAssetsManager> implements OnInit {
  @Input() type: CoreEntityType
  @Input() entity: (Performer | Sponsor | JoiResource | Exhibitor) & { showAssetsLinkInBrief?: boolean } 
  @Input() view: 'shareable' | 'actions'

  event: JoiEvent
  assets: Dictionary<Asset> = {}
  entityAssetsShareable: PublicEditEntityAssetsInfo
  generatingAssetsCode
  associatedAssetIds: string[] = []

  @Output() toggleShowEditAssetsLinkInBrief: EventEmitter<boolean> = new EventEmitter

  ngOnInit() {
    this.subProp(this.store.select('shareables', 'entityAsset', this.entity.id), 'entityAssetsShareable')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('assets', 'entities'), 'assets')
    this.selectProp(associatedAssetsReselector, this.entity.id, 'associatedAssetIds')
  }  

  async toggleAssetId(id: string) {
    if (!this.entityAssetsShareable.editableAssetIds) this.entityAssetsShareable.editableAssetIds = []
    if (!this.entityAssetsShareable.editableAssetIds.includes(id)) this.entityAssetsShareable.editableAssetIds.push(id)
    else this.entityAssetsShareable.editableAssetIds = this.entityAssetsShareable.editableAssetIds.filter(i => i !== id)
    await this.shareService.setEntityAssetsShareable(this.entityAssetsShareable)
  }

  async toggleAddNewAssets() {
    this.entityAssetsShareable.addNew = !this.entityAssetsShareable.addNew
    await this.shareService.setEntityAssetsShareable(this.entityAssetsShareable)
  }

  toggleAssetsShare() {
    if (!this.entityAssetsShareable) {
      this.createEntityAssetsShareable()
    } else if (this.entityAssetsShareable.status !== publicEditProfileStatusTypes.Off) {
      this.changeAssetsShareStatus(publicEditProfileStatusTypes.Off)
      if ((this.entity as Performer | JoiResource | Exhibitor).showAssetsLinkInBrief) this.toggleShowEditAssetsLinkInBrief.emit(false)
    } else {
      this.changeAssetsShareStatus(publicEditProfileStatusTypes.Active)
    }
  }

  async createEntityAssetsShareable (andShowInBrief = false) {
    this.generatingAssetsCode = true;
    try {
      const code = await this.shareService.generateShareCode()
      const created = await this.shareService.setEntityAssetsShareable({ code, eventId: this.event.eventId, entityType: this.type, entityId: this.entity.id, status: 'Active', addNew: true, editableAssetIds: this.associatedAssetIds })
      if (created && andShowInBrief) this.toggleShowEditAssetsLinkInBrief.emit(true) // will only fire if not errored out
    } catch(error) {
      console.error(error)
    }
    this.generatingAssetsCode = false
  }

  async changeAssetsShareStatus(status){
    await this.shareService.setEntityAssetsShareable({ ...this.entityAssetsShareable, status })
  }

  updateShowEditAssetsLinkInBrief() {
    if (this.generatingAssetsCode) return
    if (!this.entityAssetsShareable) {
      this.createEntityAssetsShareable(true)
      return
    }
    if (!(this.entity as Performer | JoiResource | Exhibitor).showAssetsLinkInBrief && this.entityAssetsShareable?.status !== 'Active') {
      this.changeAssetsShareStatus('Active')
    } else if (this.entityAssetsShareable?.status === 'Off' && (this.entity as Performer | JoiResource | Exhibitor).showAssetsLinkInBrief) {
      this.changeAssetsShareStatus('Active')
      return // for when the shareable was off but show asset link in brief was on
    }
    this.toggleShowEditAssetsLinkInBrief.emit(!(this.entity as Performer | JoiResource | Exhibitor).showAssetsLinkInBrief)
  }

}

